<template>
  <div id="layout">
    <ul id="head">
      <li class="head-left">
        <img src="../assets/images/web/logo.svg" alt="">
        <a-divider type="vertical" />
        <span class="text">浩邈账号中心</span>
      </li>
      <li class="head-right">
        <span class="text">帮助中心</span>
        <a-divider type="vertical" />
        <span @click="showPrivacy" class="text">隐私政策</span>
        <a-divider type="vertical" />
        <span @click="showRegister" class="text">用户协议</span>
        <a-divider type="vertical" />
        <span class="text" @click="logOutAccount">安全退出</span>
      </li>
    </ul>

    <section id="main">
      <aside id="aside">

        <div class="user-info">
          <div class="avatar-container">
            <div :style="userInfo.avatarStyle" class="avatar"></div>
          </div>
          <p class="name">{{userInfo.nickName}}</p>
          <p class="phone">{{userInfo.phonenumber}}</p>
        </div>

        <a-menu
          v-model:selectedKeys="selectedKeys"
          mode="inline"
          @click="({ item, key, keyPath }) => handleClick(item, key)"
        >
          <a-menu-item v-for="(item, index) of menuList.list" :key="item.key">
            <template #icon>
              <img v-if="selectedKeys[0] === item.key" :src="item.iconActive" alt="">
              <img v-else :src="item.icon" alt="">
            </template>
            {{item.title}}
          </a-menu-item>
        </a-menu>
      </aside>
      <main id="content">
        <nav class="page-title">
          <p class="text">{{ navTitle }}</p>
        </nav>

        <a-breadcrumb
          style="margin-top: 20px"
          v-if="['thirdAccount', 'loginDevice'].some(item => item === route.name)"
          :routes="breadRoutes"
        >
          <template #itemRender="{ route }">
            <span v-if="breadRoutes.indexOf(route) === breadRoutes.length - 1">
              {{ route.breadcrumbName }}
            </span>
            <router-link v-else :to="`${basePath}${route.path}`">
              {{ route.breadcrumbName }}
            </router-link>
          </template>
        </a-breadcrumb>

        <section id="pages">
          <router-view/>
        </section>
      </main>
    </section>
  </div>
</template>

<script setup>
import { reactive, ref, onBeforeMount, computed } from 'vue';
import { MailOutlined } from '@ant-design/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import { Modal } from 'ant-design-vue';
import { logOut } from '@/utils/setup/logOut';
import { useStore } from 'vuex';
import { getAgreement, showPrivacy, showRegister } from '@/utils/setup/agreement';
import { getUserInfo } from '@/utils/setup/userInfo';
import Icons from '@/assets/images/web/index';

const basePath = '/security';
const breadRoutes = ref([]);

const router = useRouter();
const route = useRoute();

const store = useStore();
const userInfo = computed(() => store.state.userInfo);

async function logOutAccount () {
  Modal.confirm({
    class: 'modal-box-confirm',
    title: '退出登录',
    content: '确定注销并退出系统吗？',
    centered: true,
    cancelText: '取消',
    okText: '确定',
    onOk: async function () {
      await logOut();
    }
  });
}

const navObj = {
  '/security/security': '账号安全',
  '/security/thirdAccount': '账号安全',
  '/security/loginDevice': '账号安全',
  '/security/userInfo': '个人信息',
  '/security/appAuth': '应用授权'
};
let navTitle = ref('');

const selectedKeys = computed({
  get (val) {
    console.log('route.path', route.path);
    setNavTitle();
    setBread();
    return [route.path];
  },
  set (val) {}
});

function setNavTitle () {
  navTitle.value = navObj[route.path];
}

/** 设置面包屑 */
function setBread () {
  if (route.name === 'thirdAccount') {
    breadRoutes.value = [
      { path: '/security', breadcrumbName: '账号安全' },
      { path: '/security', breadcrumbName: '登录方式' },
      { path: '/thirdAccount', breadcrumbName: '第三方账号' }
    ];
  } else if (route.name === 'loginDevice') {
    breadRoutes.value = [
      { path: '/security', breadcrumbName: '账号安全' },
      { path: '/security', breadcrumbName: '账号安全' },
      { path: '/loginDevice', breadcrumbName: '登录设备管理' }
    ];
  }
}

const handleClick = (item, key) => {
  selectedKeys.value = key;
  navTitle.value = navObj[key];
  router.push({ path: key });
};

let menuList = reactive({
  list: [
    { title: '账号安全', icon: Icons.authority, iconActive: Icons.authorityActive, key: '/security/security' },
    { title: '个人信息', icon: Icons.user, iconActive: Icons.userActive, key: '/security/userInfo' },
    { title: '应用授权', icon: Icons.application, iconActive: Icons.applicationActive, key: '/security/appAuth' }
  ]
});

onBeforeMount(() => {
  setBread();
  getUserInfo();
  getAgreement();
});
</script>

<style lang="scss" scoped>
#layout {
  position: relative;
  #head {
    height: 72px;
    background-color: #fff;
    position: fixed;
    top: 12px;
    left: 12px;
    right: 12px;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
    border-radius: 4px;
    .head-left {
      .ant-divider {
        height: 16px;
      }
      .text {
        color: #00132e;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .head-right {
      .text {
        padding: 0 24px;
        color: #868f9c;
        font-size: 14px;
        cursor: pointer;
      }
      .ant-divider {
        height: 10px;
      }
    }
  }

  #main {
    margin-top: 96px;
    padding: 0 12px 12px;
    display: flex;
    position: relative;
    #aside {
      position: fixed;
      top: 96px;
      left: 12px;
      bottom: 12px;
      background-color: #fff;
      width: 200px;
      border-radius: 4px;
      .user-info {
        text-align: center;
        padding: 32px;
        width: 100%;
        .avatar-container {
          display: flex;
          justify-content: center;
          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
          }
        }
        .name {
          margin-top: 12px;
          color: #2b364a;
          font-weight: 500;
          font-size: 14px;
          line-height: 14px;
          word-break: break-all;
        }
        .phone {
          margin-top: 8px;
          color: #abb2bd;
          font-size: 12px;
          line-height: 12px;
        }
      }
    }
  }
  #content {
    position: fixed;
    top: 96px;
    left: 224px;
    bottom: 12px;
    right: 12px;
    padding: 20px 40px 40px;
    border-radius: 8px;
    background-color: #fff;
    overflow-y: auto;
    .page-title {
      .text {
        color: #00132e;
        font-weight: 600;
        font-size: 24px;
        font-family: PingFang SC-Semibold, PingFang SC;
        line-height: 24px;
      }
    }
    #pages {
      margin-top: 40px;
    }
  }
}
</style>

<style lang="scss">
.ant-menu {
  width: 200px;
  color: rgba(0,0,0,.65);
}
.ant-menu-inline {
  border-right: none;
}
.ant-menu-inline .ant-menu-item {
  padding-left: 32px;
  padding-right: 32px;
  .ant-menu-title-content {
    margin-left: 16px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
  }
}
.ant-menu-item-selected {
  color: #4481EB;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
}

.ant-menu-inline .ant-menu-item::after  {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: none;
  content: '';
  transform: scaleY(1);
  opacity: 1;
  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>
